/**
 * Toggle the mobile navigation.
 */
function mmMobileMenu() {
  if (window.innerWidth > 1000) return;

  const filter = document.querySelector('.mm-filter-mega-menu');
  const header = document.querySelector('header');
  const icon = document.querySelector('.mm-header-burger');
  const mobileMenu = document.querySelector('.mm-mobile-menu-wrapper');

  if (!header || !icon || !mobileMenu) return;

  filter?.classList.add('active');
  header.classList.toggle('mm-open');
  icon.classList.toggle('mm-open');
  mobileMenu.classList.toggle('mm-menu-open');
  document.documentElement.classList.toggle('stop-scrolling');
}

function mmHideSearch() {}

/**
 * Close the mobile navigation and restore page scrolling.
 */
function mmCloseMobileMenu() {
  if (window.innerWidth > 1100) return;

  const header = document.querySelector('header');
  const icon = document.querySelector('.mm-header-burger');
  const mobileMenu = document.querySelector('.mm-mobile-menu-wrapper');

  header?.classList.remove('mm-open');
  icon?.classList.remove('mm-open');
  mobileMenu?.classList.remove('mm-menu-open');
  document.documentElement.classList.remove('stop-scrolling');

  if (typeof hideBgFilter === 'function') hideBgFilter();
}

/**
 * Slide a rayon submenu into view.
 *
 * @param {string} selector
 */
function mmMobileMenuShowNext(selector) {
  document.querySelector(selector)?.classList.add('mm-mobile-menu-elem-slided');
}

/**
 * Slide a rayon submenu out of view.
 *
 * @param {string} selector
 */
function mmMobileMenuShowPrev(selector) {
  document.querySelector(selector)?.classList.remove('mm-mobile-menu-elem-slided');
}
